export default __webpack_public_path__ + "static/media/orangePoint.fa505f87.png";